import {Component, OnInit} from '@angular/core';
import {AngularFireFunctions} from "@angular/fire/compat/functions";
import {first} from "rxjs/operators";
import {Subject} from "rxjs";

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.css']
})
export class AdminComponent implements OnInit {

  public users$ = new Subject();

  constructor(private afFun: AngularFireFunctions) {
  }

  ngOnInit() {
    this.updateUsers()
  }

  updateUsers() {
    const callable = this.afFun.httpsCallable('getPendingUsers');
    callable({})
      .subscribe(resp => {
        this.users$.next(resp.result.users);
      }, err => {
        console.error(err);
      });
  }

  verifyUser(user: any, verified: boolean) {
    const callable = this.afFun.httpsCallable('manageClaim');
    const claimMap = {
      verified: verified,
      blocked: !verified
    };
    callable({email: user.email, claimMap: claimMap})
      .pipe(first())
      .subscribe(resp => {
        this.updateUsers();
        console.log({resp});
      }, err => {
        console.error({err});
      });
  }

}
